import { useQuery } from '@tanstack/react-query';
import { ApiError } from '@/api/ui/requests/core/ApiError';
import { OrganizationVideoService } from '@/api/ui/requests/services/OrganizationVideoService';
import useOrganisation from '@/hooks/useOrganisation';

export const knowledgeBaseVideoQueryKey = (selectedOrganisationId?: string | null) => ['knowledgeBaseVideo', selectedOrganisationId];

export async function getKnowledgeBaseVideoUrl(selectedOrganisationId: string): Promise<string | null> {
  try {
    const res = await OrganizationVideoService.getOrganizationVideo(selectedOrganisationId);
    return res.url ?? null;
  } catch (e) {
    if (e instanceof ApiError && (e.status === 404 || e.status === 403)) return null;
    throw e;
  }
}

export function useKnowledgeBaseVideoQuery(selectedOrganisationId?: string | null, enabled = true) {
  return useQuery({
    queryKey: knowledgeBaseVideoQueryKey(selectedOrganisationId),
    enabled: enabled && !!selectedOrganisationId,
    refetchOnWindowFocus: false,
    useErrorBoundary: false,
    retry: false,
    queryFn: () => getKnowledgeBaseVideoUrl(selectedOrganisationId!),
  });
}

export function useKnowledgeBaseVideo() {
  const { selectedOrganisationId } = useOrganisation();

  return useKnowledgeBaseVideoQuery(selectedOrganisationId);
}

export default useKnowledgeBaseVideo;
